import { AU_STRIPE_KEY, GB_STRIPE_KEY, GLOBAL_STRIPE_KEY } from "core/config/config";

export const publicKeys = [
    { country: 'default', key: GLOBAL_STRIPE_KEY },
    { country: 'au', key: AU_STRIPE_KEY },
    { country: 'gb', key: GB_STRIPE_KEY },
];